import 'babel-polyfill'
import '@/polyfill'
import Vue from 'vue'
import '@/plugins/vuetify'
import App from './App.vue'
import globalComponents from '@/components/global/index.vue'
import router from '@/router'
import store from '@/store'
import VueObserveVisibility from 'vue-observe-visibility'
import 'croppie/croppie.css'
import 'intersection-observer'
import VueYandexMetrika from 'vue-yandex-metrika'
import moment from 'moment'
moment.locale('ru')

Vue.config.productionTip = false

router.beforeEach(( to, from, next ) => {
  store.dispatch('navigate', to)
  next()
})
Vue.use(VueObserveVisibility)
const components = globalComponents.components
Object.keys(components).map(x => components[x]).forEach(x => { Vue.component(x.name, x) })

const docTitlePlugin = {
  install: function (Vue) {
    const _prop = {
      get: function () { return document.title },
      set: function (v) { document.title = v }
    }
    Object.defineProperty(Vue, 'docTitle', _prop)
    Object.defineProperty(Vue.prototype, '$docTitle', _prop)
  }
}
Vue.use(docTitlePlugin)

Vue.use(VueYandexMetrika, {
    id: 76394914,
    router: router,
    env: process.env.NODE_ENV
    // other options
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

const { version } = require('../package.json')
console.log(`v${version}`)

store.dispatch('connect', { router })
